import React from "react";
import { connect } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Validations from "../../component/Utility/Validations";
import * as userActions from "../../actions/index";
import moment from "moment";
import TwoFactorQRModal from "./twoFactorQRModal";
import OTPModal from "./otpScreen";
import ResetSuccessModal from "./ResetSuccessModal";

// Safely parse user info from localStorage
let user_info = null;
try {
    const userInfoString = localStorage.getItem("bss_authuser");
    user_info = userInfoString ? JSON.parse(userInfoString) : null;
} catch (error) {
    console.error("Error parsing user info from localStorage:", error);
    user_info = null;
}

const school_code = user_info?.school_code === null || user_info === null ? "" : user_info?.school_code;

class signin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hiddenpassword: true,
            login_form: {
                email: {
                    type: "email",
                    value: "",
                    valid: true,
                    error_msg: "",
                    placeholder: "Enter your email address",
                    validations: { required: true, email: true },
                },
                password: {
                    type: "password",
                    value: "",
                    valid: true,
                    error_msg: "",
                    placeholder: "Enter your password",
                    validations: { required: true, min_length: 8, password: true },
                },
                remember: {
                    valid: true,
                    error_msg: "",
                    type: "checkbox",
                    isChecked: false,
                    value: "remember",
                    label: "Keep me signed in",
                    validations: { required: false },
                },
            },
            is_form_valid: false,
            passwordshow: false,
            redirect_url: "",
            isAuthenticated: false,

            // States for Two Factor Modal
            showTwoFactorModal: false,
            qrCodeValue: "",
            loginResponseData: null,

            // States for OTP Modal
            showOTPModal: false,
            user_uuid: "",
            isOTPVerifying: false,
            viaEmail: false,

            // States for Reset Success Modal
            showResetSuccessModal: false,
            resetSuccessMessage: "",

            // Loading states to prevent double API calls
            isSendingEmailOtp: false,
            isResendingEmailOtp: false,
        };

        // Instance flags to prevent double API calls (faster than setState)
        this.isEmailOtpInProgress = false;
        this.isResendEmailOtpInProgress = false;

        this.toggleShow = this.toggleShow.bind(this);
        this.handleSendEmailOtp = this.handleSendEmailOtp.bind(this);
        this.handleResendEmailOtp = this.handleResendEmailOtp.bind(this);
    }

    componentDidMount() {
        // Check for URL parameters when component mounts
        this.checkURLParameters();
    }

    componentWillUnmount() {
        // Clear any pending timeouts
        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
        }
    }

    // Method to check URL parameters for reset success message
    checkURLParameters = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const msgParam = urlParams.get('msg');

        if (msgParam) {
            // Show the reset success modal
            this.setState({
                showResetSuccessModal: true,
                resetSuccessMessage: this.decodeMessage(msgParam)
            });
        }
    };

    // Method to decode the message parameter
    decodeMessage = (msg) => {
        try {
            return decodeURIComponent(msg);
        } catch (error) {
            return "Your 2FA reset link is reset and you can now login normally.";
        }
    };

    // Method to handle Reset Success Modal OK click
    handleResetSuccessOk = () => {
        // Close the modal
        this.setState({
            showResetSuccessModal: false,
            resetSuccessMessage: ""
        });

        // Remove the msg parameter from URL and redirect to clean login page
        const currentUrl = new URL(window.location);
        currentUrl.searchParams.delete('msg');

        // Use pushState to update URL without page reload
        window.history.pushState({}, '', currentUrl.pathname + currentUrl.search);
    };

    toggleShow() {
        this.setState({ hiddenpassword: !this.state.hiddenpassword });
    }

    inputChangeHandler(event, identifier) {
        const update_login_form = { ...this.state.login_form };
        const form_element = { ...update_login_form[identifier] };
        if (identifier === "remember") {
            form_element.isChecked = event.target.checked;
        } else {
            form_element.value = event.target.value;
        }
        update_login_form[identifier] = form_element;
        this.setState({ login_form: update_login_form });

        clearTimeout(this.typingTimeout);

        this.typingTimeout = setTimeout(() => {
            // Check Validation
            let validate_element = Validations(form_element);
            form_element.valid = validate_element.valid;
            form_element.error_msg = validate_element.error_msg;

            update_login_form[identifier] = form_element;
            let is_form_valid = true;
            for (let identifier in update_login_form) {
                is_form_valid = update_login_form[identifier].valid && is_form_valid;
            }

            this.setState({
                login_form: update_login_form,
                is_form_valid: is_form_valid,
            });
        }, 2000);
    }

    // Handle Two Factor Modal actions
    handleTwoFactorConfirm = () => {
        // After user confirms they've scanned the QR code, show OTP modal
        this.setState({
            showTwoFactorModal: false,
            showOTPModal: true,
            qrCodeValue: "",
            loginResponseData: null,
            viaEmail: false
        });
    };

    handleTwoFactorClose = () => {
        this.setState({
            showTwoFactorModal: false,
            qrCodeValue: "",
            loginResponseData: null,
            user_uuid: ""
        });
        console.log(this.state.login_form, "login_formlogin_formlogin_form");
    };

    // When user clicks Send email OTP from QR modal
    handleSendEmailOtp(e) {
        // Prevent event bubbling if event exists
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        // Check both state and instance flag to prevent double calls
        if (this.state.isSendingEmailOtp || this.isEmailOtpInProgress) {
            console.log("API call already in progress, skipping duplicate request");
            return;
        }

        // Set both flags immediately (instance flag is synchronous, state is async)
        this.isEmailOtpInProgress = true;
        this.setState({ isSendingEmailOtp: true });

        console.log("handleSendEmailOtp called - API will be hit ONCE");

        const form_data = { user_uuid: this.state.user_uuid };

        const handleSuccess = (response) => {
            // Reset flags
            this.isEmailOtpInProgress = false;

            this.setState({
                showTwoFactorModal: false,
                showOTPModal: true,
                viaEmail: true,
                user_uuid: response && response.user_uuid ? response.user_uuid : this.state.user_uuid,
                isSendingEmailOtp: false
            });

            // Show success message if available
            if (response && response.success === true) {
                toast.success(response.message || "Email OTP sent.", {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        };

        const handleError = (error) => {
            // Reset flags
            this.isEmailOtpInProgress = false;

            // Even if sending fails, open OTP modal so user can enter code if they received it
            this.setState({
                showTwoFactorModal: false,
                showOTPModal: true,
                viaEmail: true,
                isSendingEmailOtp: false
            });
            toast.error("Failed to send email OTP. Please try again.", {
                position: toast.POSITION.TOP_CENTER
            });
        };

        // Call the appropriate API
        if (this.props.onSendEmailOtp) {
            this.props.onSendEmailOtp(form_data)
                .then(handleSuccess)
                .catch(handleError);
        } else if (this.props.onSend2FAResetLink) {
            // Fallback to legacy reset link API if sendEmailOtp not available
            this.props.onSend2FAResetLink(form_data)
                .then(handleSuccess)
                .catch(handleError);
        } else {
            // No action wired — just open OTP modal in email mode
            this.isEmailOtpInProgress = false;
            this.setState({
                showTwoFactorModal: false,
                showOTPModal: true,
                viaEmail: true,
                isSendingEmailOtp: false
            });
        }
    }

    // When user clicks Resend inside OTP modal (email mode)
    handleResendEmailOtp(e) {
        // Prevent event bubbling if event exists
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        // Check both state and instance flag to prevent double calls
        if (this.state.isResendingEmailOtp || this.isResendEmailOtpInProgress) {
            console.log("Resend API call already in progress, skipping duplicate request");
            return;
        }

        // Set both flags immediately
        this.isResendEmailOtpInProgress = true;
        this.setState({ isResendingEmailOtp: true });

        console.log("handleResendEmailOtp called - API will be hit ONCE");

        const form_data = { user_uuid: this.state.user_uuid };

        const handleResponse = (response) => {
            // Reset flags
            this.isResendEmailOtpInProgress = false;
            this.setState({ isResendingEmailOtp: false });

            if (response && response.success === true) {
                toast.success(response.message || "Email OTP resent.", {
                    position: toast.POSITION.TOP_CENTER
                });
            } else {
                toast.error(response.message || "Failed to resend email OTP.", {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        };

        const handleError = () => {
            // Reset flags
            this.isResendEmailOtpInProgress = false;
            this.setState({ isResendingEmailOtp: false });

            toast.error("An error occurred while resending email OTP.", {
                position: toast.POSITION.TOP_CENTER
            });
        };

        if (this.props.onSendEmailOtp) {
            this.props.onSendEmailOtp(form_data)
                .then(handleResponse)
                .catch(handleError);
        } else if (this.props.onSend2FAResetLink) {
            this.props.onSend2FAResetLink(form_data)
                .then(handleResponse)
                .catch(handleError);
        } else {
            // Reset flags
            this.isResendEmailOtpInProgress = false;
            this.setState({ isResendingEmailOtp: false });
            toast.info("Resend requested.", { position: toast.POSITION.TOP_CENTER });
        }
    }

    // Handle OTP Modal actions
    handleOTPVerify = (otpCode, authMethod) => {
        this.setState({ isOTPVerifying: true });
        console.log(this.state.user_uuid, "user_uuiduser_uuiduser_uuid");

        // Prepare form data with user_uuid, twofa_token, and auth_method for Verify2FA API
        const form_data = {
            user_uuid: this.state.user_uuid,
            twofa_token: otpCode,
            auth_method: authMethod // "email" or "google"
        };

        console.log("OTP verification data:", form_data);

        // Call the Verify2FA API
        this.props.onVerify2FA(form_data).then((response) => {
            this.setState({ isOTPVerifying: false });

            if (response.success === true) {
                console.log("2FA verification successful", response);

                // Close OTP modal and proceed with normal login flow
                this.setState({
                    showOTPModal: false,
                    qrCodeValue: "",
                    loginResponseData: null,
                    user_uuid: ""
                });

                this.proceedWithLogin(response);

                toast.success("Two-factor authentication verification successful!", {
                    position: toast.POSITION.TOP_CENTER,
                });

            } else {
                toast.error(response.message || "Invalid verification code. Please try again.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }).catch((error) => {
            this.setState({ isOTPVerifying: false });
            toast.error("An error occurred during verification. Please try again.", {
                position: toast.POSITION.TOP_CENTER,
            });
        });
    };

    // Method to handle 2FA reset
    handleOTPReset = () => {
        const form_data = {
            email: this.state.login_form.email.value
        };

        console.log("2FA reset data:", form_data);

        // Call the Send2FAResetLink API
        this.props.onSend2FAResetLink(form_data).then((response) => {
            if (response.success === true) {
                console.log("2FA reset successful", response);

                // Show success message from API response
                toast.success(response.message || "2FA reset link has been sent successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });

                // Close OTP modal
                this.setState({
                    showOTPModal: false,
                    qrCodeValue: "",
                    loginResponseData: null,
                    user_uuid: "",
                    isOTPVerifying: false
                });

            } else {
                toast.error(response.message || "Failed to send 2FA reset link. Please try again.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }).catch((error) => {
            console.error("2FA reset error:", error);
            toast.error("An error occurred while sending reset link. Please try again.", {
                position: toast.POSITION.TOP_CENTER,
            });
        });
    };

    handleOTPClose = () => {
        this.setState({
            showOTPModal: false,
            qrCodeValue: "",
            loginResponseData: null,
            user_uuid: "",
            isOTPVerifying: false
        });
    };

    proceedWithLogin = (response) => {
        // Original login continuation logic
        this.props.onGetLoginUserPermissions().then((permissionResponse) => {
            console.log("permisssion", permissionResponse);
            if (permissionResponse.success === true) {
                setTimeout(() => {
                    window.location.href = `${permissionResponse.data.user_school.school_code}/dashboard`;
                }, 500);
            } else {
                // Handle permission error
            }
        });

        setTimeout(() => {
            if (response?.data?.role_type === 1) {
                window.location.href = "/superadmin/school";
            } else {
                if (response?.data?.user_school?.subscriptionData?.type === "demo") {
                    if (response?.data?.user_school?.subscriptionData?.end_date < moment(new Date()).format('YYYY-MM-DD')) {
                        toast.error("Your trial period has concluded. Kindly get in touch with BSS support to purchase a subscription. ", {
                            position: toast.POSITION.TOP_CENTER,
                        });
                    } else {
                        window.location.href = `${response.data.user_school.school_code}/dashboard`;
                    }
                } else {
                    if (response.data.user_school.subscriptionData.end_date < moment(new Date()).format('YYYY-MM-DD')) {
                        toast.error("Your subscription has expired. Please contact BSS support to renew and extend your subscription.", {
                            position: toast.POSITION.TOP_CENTER,
                        });
                    } else {
                        window.location.href = `${response.data.user_school.school_code}/dashboard`;
                    }
                }
            }
        }, 500);
    };

    loginSubmitHandler = (event) => {
        event.preventDefault();
        let is_form_valid = true;
        const update_login_form = this.state.login_form;
        update_login_form.email.value = update_login_form.email.value;
        for (let key in update_login_form) {
            let form_element = update_login_form[key];
            let validate_element = Validations(form_element);

            is_form_valid = validate_element.valid === false ? false : is_form_valid;
            form_element.valid = validate_element.valid;
            form_element.error_msg = validate_element.error_msg;

            update_login_form[key] = form_element;
        }
        this.setState({ login_form: update_login_form });

        if (is_form_valid) {
            const form_data = {};
            for (let key in this.state.login_form) {
                if (key === "remember") {
                    if (this.state.login_form[key].isChecked === false) {
                        break;
                    }
                }
                form_data[key] = this.state.login_form[key].value;
            }

            this.props.onSignIn(form_data).then((response) => {
                console.log("form_data", response);
                if (response.success === true) {
                    console.log("form_data", response);

                    // Check if response contains QR code for two-factor authentication setup
                    if (response.qrCode && response.twof_auth) {
                        console.log(response, "responseresponse - QR Code setup");
                        // Show Two Factor Modal and store the user_uuid
                        this.setState({
                            showTwoFactorModal: true,
                            qrCodeValue: response.qrCode,
                            loginResponseData: response,
                            user_uuid: response.user_uuid || ""
                        });

                        return; // Don't proceed with normal login flow yet
                    }

                    // Check if response requires 2FA verification (user already has 2FA setup)
                    if (response && response.setupRequired === false && response.twof_auth === true) {
                        console.log(response, "responseresponse - 2FA verification required");
                        // Show OTP Modal directly and store the user_uuid
                        this.setState({
                            showOTPModal: true,
                            user_uuid: response.user_uuid || "",
                            viaEmail: false
                        });

                        return; // Don't proceed with normal login flow yet
                    }

                    // Normal login flow (when no 2FA setup required)
                    this.proceedWithLogin(response);

                } else {
                    toast.error(response.message, {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            });
        }
    };

    render() {
        const { login_form } = this.state;
        console.log('login_form=========', login_form);

        return (
            <React.Fragment>
                <ToastContainer />
                {this.state.isAuthenticated ? <Navigate to={this.state.redirect_url} /> : null}

                {/* Reset Success Modal */}
                <ResetSuccessModal
                    show={this.state.showResetSuccessModal}
                    onHide={this.handleResetSuccessOk}
                    onOkClick={this.handleResetSuccessOk}
                    message={this.state.resetSuccessMessage}
                />

                {/* Two Factor QR Modal */}
                <TwoFactorQRModal
                    show={this.state.showTwoFactorModal}
                    onHide={() => this.setState({ showTwoFactorModal: false })}
                    qrCodeValue={this.state.qrCodeValue}
                    onConfirm={this.handleTwoFactorConfirm}
                    onClose={this.handleTwoFactorClose}
                    onSendEmailOtp={this.handleSendEmailOtp}
                    isSendingEmailOtp={this.state.isSendingEmailOtp}
                />

                {/* OTP Verification Modal */}
                <OTPModal
                    show={this.state.showOTPModal}
                    onHide={this.handleOTPClose}
                    onVerifyOtp={this.handleOTPVerify}
                    onResetOtp={this.handleOTPReset}
                    onClose={this.handleOTPClose}
                    isVerifying={this.state.isOTPVerifying}
                    onSendEmailOtp={this.handleResendEmailOtp}
                    viaEmail={this.state.viaEmail}
                    isResendingEmailOtp={this.state.isResendingEmailOtp}
                />

                <div className="d-flex flex-column flex-root h-100">
                    <div className="d-flex flex-column flex-column-fluid position-x-center bgi-no-repeat cstm-bgfixed">
                        <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
                            <div className="w-lg-500px bg-body rounded shadow-sm p-8 p-lg-8 mx-auto" id="cstm-effect">
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                    <Link to="/" className="text-center d-block">
                                        <img alt="Logo" src="/assets/media/logos/BSS_Transparent.png" style={{ height: '100px' }} />
                                    </Link>
                                    <div className="text-center">
                                        <h1 className="text-dark mb-3">Log In</h1>
                                        <h6>(Boarding Admin & Boarding Staff)</h6>
                                    </div>
                                    <Link to="/" className="text-center d-block">
                                        <img alt="Logo" src="/assets/media/logos/newlogo.png" style={{ height: '75px' }} />
                                    </Link>
                                </div>
                                <form className="form w-100" onSubmit={this.loginSubmitHandler}>
                                    <div className="fv-row mb-10">
                                        <label className="form-label fw-bolder text-dark">Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder={login_form.email.placeholder}
                                            value={login_form.email.value ? login_form.email.value : ""}
                                            onChange={(event) => this.inputChangeHandler(event, "email")}
                                        />
                                        {!login_form.email.valid ? <div className="error field-error">{login_form.email.error_msg}</div> : ""}
                                    </div>

                                    <div className="fv-row mb-10">
                                        <div className="d-flex flex-stack mb-2">
                                            <label className="form-label fw-bolder text-dark mb-0">Password</label>
                                        </div>
                                        <div className="position-relative">
                                            <input
                                                type={this.state.hiddenpassword ? 'password' : 'text'}
                                                className="form-control"
                                                placeholder={login_form.password.placeholder}
                                                value={login_form.password.value ? login_form.password.value : ""}
                                                onChange={(event) => this.inputChangeHandler(event, "password")}
                                            />
                                            <span onClick={this.toggleShow} className="btn btn-icon position-absolute translate-middle top-50 end-0" style={{ marginTop: "-3px" }} data-kt-password-meter-control="visibility">
                                                {this.state.hiddenpassword ? <i className="bi bi-eye-slash fs-2"></i> : <i className="bi bi-eye fs-2"></i>}
                                            </span>
                                        </div>
                                        {!login_form.password.valid ? <div className="error field-error">{login_form.password.error_msg}</div> : ""}
                                    </div>

                                    <div className="fv-row mb-10 text-end">
                                        <Link to="/forgot-password" className="fw-bolder">
                                            Forgot Password ?
                                        </Link>
                                    </div>
                                    <div className="text-center">
                                        <button type="submit" className="btn btn-lg btn-primary w-100">
                                            <span className="indicator-label">Login</span>
                                            <span className="indicator-progress">
                                                Please wait... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        loader: state.Auth.loader,
        error: state.Auth.error,
    };
}

const mapDispatchToProps = {
    onSignIn: userActions.SignIn,
    onGetLoginUserPermissions: userActions.GetLoginUserPermissions,
    onVerify2FA: userActions.Verify2FA,
    onSend2FAResetLink: userActions.Send2FAResetLink,
    onSendEmailOtp: userActions.SendEmailOtp,
};

export default connect(mapStateToProps, mapDispatchToProps)(signin);